import { render, staticRenderFns } from "./TestDocument.vue?vue&type=template&id=5f0e2dcf&scoped=true&"
import script from "./TestDocument.vue?vue&type=script&lang=js&"
export * from "./TestDocument.vue?vue&type=script&lang=js&"
import style0 from "./TestDocument.vue?vue&type=style&index=0&id=5f0e2dcf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0e2dcf",
  null
  
)

export default component.exports